// App.js
 
import { jwtDecode } from "jwt-decode";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Button from 'react-bootstrap/Button';
import { Container } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import axios from 'axios'
import { useState, useEffect } from "react";
import Card from 'react-bootstrap/Card';
import zedLogo from './zedlogo.png';
import titleZedLogo from './title-zedlogo.png';
import { useAuth, hasAuthParams  } from "react-oidc-context";
 
function App() {
  const auth  = useAuth(); 
  const [hasTriedSignin, setHasTriedSignin] = useState(false);
  const [idToken, setIdToken] = useState();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [refreshToken, setRefreshToken] = useState();
  const [error, setError] = useState();
  const [showError, setShowError] = useState(false);
  const [clinics, setClinics] = useState([]);


  const verify = ((clinic) =>
  {
    if(clinic)
    {
      const instance = axios.create();
      instance.defaults.timeout = 60000;
      
      instance.post(`${process.env.REACT_APP_LAMBDA_URI}`,
        {
          clinic: clinic.siteName,
          id_token: idToken,
          refresh_token: refreshToken,
        },
        {
          headers: {
            Authorization: `${idToken}`,
          },
        }
      )
      .then((response) => 
      {
        if(response.status === 200 && response.data.RedirectUrl)
        {
          window.location.href = response.data.RedirectUrl;
        }
        else
        {
          setError(`Unable to verify clinic ${clinic.displayName}`)
          setShowError(true)
        }
      }) 
      .catch((err) => 
      {
        setError(`Unable to verify clinic ${clinic.displayName}`)
        setShowError(true)
      });
    }
  })

  const handleClinicSelect = ((clinic) => 
  {
    verify(clinic)
  })

  useEffect(() => {
    try
    {
      if (!hasAuthParams() && !auth.isAuthenticated && !auth.isLoading && !hasTriedSignin) 
      {
        auth.signinRedirect();
        setHasTriedSignin(true);
      }
      
      let id_token;
      let refresh_token;
      if(auth.user?.id_token)
      {
        id_token = jwtDecode(auth.user?.id_token);
        refresh_token = auth.user?.refresh_token;
      }
      else
      {
        return;
      }

      if(!id_token || !refresh_token)
      {
        window.location.href = '/Login';
      }
      
      setIdToken(auth.user?.id_token);
      setRefreshToken(auth.user?.refresh_token);

      const email = auth.user?.profile.email;
      const zcloudUrl = process.env.REACT_APP_ZCLOUD_USER_URI;
      setShowChangePassword(email.includes(zcloudUrl));
        
      let clinics = id_token["custom:sites"]
        .replace('[', '')
        .replace(']', '')
        .split(',')
        .map(element => {
          return element.replaceAll('\"', '')
        }); 
        
      if(!clinics || clinics.length === 0)
      {
        clinics = id_token["cognito:groups"];
      }
        
      if(!clinics || clinics.length === 0)
      {
        window.location.href = '/Login';
      }
      
      const instance = axios.create();
      instance.defaults.timeout = 60000;

      instance.post(`${process.env.REACT_APP_CLINIC_DISPLAY_NAMES_URI}`,
        {
          sitelist: clinics,
        },
      )
      .then((response) => 
      {
        if(response.status === 200 && response.data.siteDetails)
        {
          setClinics(response.data.siteDetails)
          setShowError(false)
        }
        else
        {
          window.location.href = '/Login';
        }
      }) 
      .catch((err) => 
      {
        window.location.href = '/Login';
      });
    }
    catch(e)
    {
      window.location.href = '/Login';
    }
  }, [auth])

  const handleLogout = () => {
    const domain = process.env.REACT_APP_LOGIN_REDIRECT_URI; 
    const clientId = process.env.REACT_APP_LOGIN_CLIENT_ID; 

    setIdToken(null);
    setRefreshToken(null);
    setClinics([]);

    auth.signoutRedirect({
      extraQueryParams: {
        client_id: clientId,
        logout_uri: `${domain}/login`,
      },
    });  
  };

  const handleChangePassword = () => {
    window.location.href = process.env.REACT_APP_CHANGE_PASSWORD_URI;
  };

  return (
  <>
    {showError &&
      (
        <div  className="m-5">
          <Container>
            <Row></Row>
            <Row>
              <Col></Col>
              <Col className="d-flex justify-content-center mt-10">
                <Alert variant='danger'>{error}</Alert>
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col></Col>
              <Col className="d-flex justify-content-center">
                <Card.Link href="/login">Login</Card.Link>
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
      )}

      {!showError &&
      (
        <div >
          <div className="d-flex flex-wrap justify-content-center justify-content-md-end p-3 gap-2">
            
            {showChangePassword && (<Button variant="secondary" onClick={handleChangePassword}>
              Change Password
            </Button>)}

            <Button variant="danger" onClick={handleLogout}>
              Logout
            </Button>
          </div>
            <div className="container text-center p-4">
            <div style={{ 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "center",
              marginBottom: "10px"
            }}>
              <img 
              src={titleZedLogo} 
              alt="logo"
              className="img-fluid"
              style={{ maxWidth: "475px", width: "100%", height: "auto" }}
              />
              <h1></h1>
            </div>
            <Alert variant='info'>Select a clinic from the list to log in</Alert>
            <div className="row justify-content-center">
              {clinics.map((clinic, index) => {return <div key={index} className="col-sm-12 col-lg-2" >
                <Card 
                  className="m-2"
                  style={{ width: "auto", height: "10rem"}}
                  key={index} 
                  onClick={() => handleClinicSelect(clinic)}>
                    <Button variant="outline-primary" className="w-100 h-100" style={{ border: "black"}}>
                      <div style={{flexDirection: "column", justifyContent: "center"}}>
                        <img style={{ width: 60, height: 60}} src={zedLogo} alt="fireSpot"/>
                        <p>{clinic.displayName}</p>
                      </div>
                    </Button>
                </Card></div>
              })}
            </div>
          </div>
        </div>
        )
      }
  </>
  )
}
 
export default App;